import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

import { getEnv } from '@motorway/motorway-handshake-components';

import { getVehicleQueryParams } from './api/helpers/auth.helpers';
import { App } from './App.tsx';

import './index.css';

const { hostname } = globalThis.location ?? {};
const sampleRate = hostname.includes('localhost')
  ? 0
  : 100;

const clientToken = 'pubbd92d41c18830f51cca5a4fd5343055d';
const site = 'datadoghq.eu';
const env = getEnv();
const service = 'handshake-driver-webapp';

datadogRum.init({
  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  applicationId: '33fd5bb9-d9c5-4f0a-9635-c32ddb11e1e6',
  clientToken,
  defaultPrivacyLevel: 'allow',
  env,
  service,
  sessionReplaySampleRate: sampleRate,
  sessionSampleRate: sampleRate,
  site,
  trackBfcacheViews: true,
});

datadogLogs.init({
  clientToken,
  env,
  forwardErrorsToLogs: true,
  service,
  sessionSampleRate: sampleRate,
  site,
});

const root = document.getElementById('root');

if (root) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

getVehicleQueryParams();
datadogLogs.logger.info('Initial page view', { path: location.pathname });

document.addEventListener('visibilitychange', () => {
  datadogLogs.logger.info('Page visibility changed', { visibilityState: document.visibilityState });
});
